import { DEFAULT_LOCALE, LOCALES } from './constants';
import { getStoredLocale } from './localeStorage';

function localeFromBrowser() {
  if (typeof navigator === 'undefined') {
    return null;
  }
  const candidates = [
    navigator.language,
    ...(navigator.languages || []),
  ].filter(Boolean);

  for (const lang of candidates) {
    const lower = lang.toLowerCase();
    if (lower === 'fi' || lower.startsWith('fi-')) {
      return 'fi';
    }
    if (lower.startsWith('de')) {
      return 'de';
    }
    if (lower.startsWith('en')) {
      return 'en';
    }
  }
  return null;
}

/** Resolve locale: storage → browser → default */
export function detectLocale() {
  const stored = getStoredLocale();
  if (stored) {
    return stored;
  }
  const fromBrowser = localeFromBrowser();
  if (fromBrowser && LOCALES.includes(fromBrowser)) {
    return fromBrowser;
  }
  return DEFAULT_LOCALE;
}
